/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OrganizationRemoteSessionIssuer,
  OrganizationRemoteSessionIssuer$inboundSchema,
} from "./organizationremotesessionissuer.js";

/**
 * Result type for the organization-administrator issuer listing — organizational and project-specific issuers across the org.
 */
export type ListOrganizationRemoteSessionIssuersResult = {
  items: Array<OrganizationRemoteSessionIssuer>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionIssuersResult$inboundSchema:
  z.ZodMiniType<ListOrganizationRemoteSessionIssuersResult, unknown> = z.pipe(
    z.object({
      items: z.array(OrganizationRemoteSessionIssuer$inboundSchema),
      next_cursor: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "next_cursor": "nextCursor",
      });
    }),
  );

export function listOrganizationRemoteSessionIssuersResultFromJSON(
  jsonString: string,
): SafeParseResult<
  ListOrganizationRemoteSessionIssuersResult,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationRemoteSessionIssuersResult$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListOrganizationRemoteSessionIssuersResult' from JSON`,
  );
}
